"use client";

import { useState, useEffect } from "react";
import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-solidity";
import "./CodeSnippet.css";

const CodeSnippet = ({ fullCode, className, lineNumber = 8 }) => {
    const [displayedCode, setDisplayedCode] = useState("");
    const [initialCode, setInitialCode] = useState("");
    const [remainingCode, setRemainingCode] = useState("");
    const [highlightedCode, setHighlightedCode] = useState("");
    const [animationComplete, setAnimationComplete] = useState(false);

    useEffect(() => {
        // Split the code into lines
        const codeLines = fullCode.split("\n");
        const firstTenLines = codeLines.slice(0, lineNumber).join("\n");
        const remainingLines = codeLines.slice(lineNumber).join("\n");

        setInitialCode(firstTenLines);
        setRemainingCode(remainingLines);

        // Highlight the initial code
        const highlightedInitialCode = Prism.highlight(
            firstTenLines,
            Prism.languages.solidity,
            "solidity"
        );
        setHighlightedCode(highlightedInitialCode);
    }, [fullCode]);

    useEffect(() => {
        if (animationComplete) {
            // Restart animation if it was previously completed
            setDisplayedCode("");
            setAnimationComplete(false);
        }

        let index = 0;
        const intervalId = setInterval(() => {
            if (index < remainingCode.length) {
                setDisplayedCode((prev) => prev + remainingCode[index]);
                index++;
            } else {
                clearInterval(intervalId);
                setAnimationComplete(true);
            }
        }, 50); // Typing speed (50 ms per character)

        return () => clearInterval(intervalId);
    }, [remainingCode, animationComplete]);

    useEffect(() => {
        const combinedCode = initialCode + displayedCode;

        const cleanedCode = combinedCode.replace(/undefined/g, "");

        const highlightedCode = Prism.highlight(
            cleanedCode,
            Prism.languages.solidity,
            "solidity"
        );
        setHighlightedCode(highlightedCode);
    }, [displayedCode, initialCode]);

    return (
        <div
            style={{
                fontFamily: "monospace",
                background: "#2d2d2d",
                color: "#f8f8f2",
                padding: "20px",
                borderRadius: "10px",
                whiteSpace: "pre-wrap",
                height: "550px",
                overflowY: "auto",
                overflowX: "auto",
            }}
            className={`${className}`}
        >
            <pre
                className="language-solidity"
                dangerouslySetInnerHTML={{ __html: highlightedCode }}
                style={{
                    margin: "0",
                    padding: "0",
                    borderRadius: "0",
                }}
            />
        </div>
    );
};

export default CodeSnippet;
